// extracted by mini-css-extract-plugin
export default {"root":"index_root__Rohds","modal":"index_modal__6TRT7","header":"index_header__1EmIs","close":"index_close__7T+jZ","body":"index_body__Q3ty7"};